import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default React.memo(props => (
  <SvgIcon {...props} width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.00016 3.93256L3.93273 8L8.00016 12.0674L12.0676 8L8.00016 3.93256ZM7.46279 3.05572C7.60537 2.91331 7.79865 2.83333 8.00016 2.83333C8.20168 2.83333 8.39495 2.91331 8.53753 3.05572L12.9442 7.46241C13.0866 7.60499 13.1668 7.79848 13.1668 8C13.1668 8.20151 13.0868 8.39478 12.9444 8.53736L8.53775 12.9441C8.39517 13.0865 8.20168 13.1667 8.00016 13.1667C7.79865 13.1667 7.60537 13.0867 7.46279 12.9443L3.05611 8.53759C2.9137 8.395 2.8335 8.20151 2.8335 8C2.8335 7.79848 2.91348 7.60521 3.05589 7.46263L7.46279 3.05572Z"
      fill="currentColor"
    />
  </SvgIcon>
));
